<div class="grow">
  <fin-itinerary-timeline
    *ngIf="outbound$ && (outbound$ | async)"
    [bound]="outbound$ | async"
    [locations]="locations$ | async"
    [boundType]="OUTBOUND"
    [isBookingFlow]="isBookingFlow"
  ></fin-itinerary-timeline>

  <div
    *ngIf="hasAirportChangeBetweenBounds$ | async"
    class="flex flex--middle heather-700-text font-body-1 pr-medium-x pr-xsmall-y airport-change"
  >
    <div class="flex--nogrow pr-xsmall">
      <fcom-icon class="alert-block is-small" name="info"></fcom-icon>
    </div>
    <div class="arrow-block rounded mr-xsmall-x">
      <div class="arrow-left heather-50-bg border z2"></div>
      <div class="pr-xsmall heather-50-bg relative z3">
        <span>{{ 'itinerary.note' | finLocalization }}:</span>
        <span>{{ 'itinerary.airportChangeBetweenBounds' | finLocalization }}</span>
      </div>
    </div>
  </div>

  <fin-itinerary-timeline
    *ngIf="inbound$ && (inbound$ | async)"
    [bound]="inbound$ | async"
    [locations]="locations$ | async"
    [boundType]="INBOUND"
    [isBookingFlow]="isBookingFlow"
  ></fin-itinerary-timeline>
</div>
